import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class D4WPatientsHFTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['patients_hf.csv'];
  commands = [`sed -i -e '1s/default/is_default/'`];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
